<template>
  <div class="item-base " v-if="NewsItem">
    <div class="item-img">
      <el-image :src="'http://'+ NewsItem.address" class="img"></el-image>
    </div>
    <div class="item-title">
      <span>{{NewsItem.description}}</span>
    </div>
    <div class="item-time">
<!--      <span>查看更多 <i class="el-icon-arrow-right"></i></span>-->
<!--      <span>{{NewsItem.createTime | Date}}</span>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeNewsItem",
  props:{
    NewsItem:{

    }
  },
  filters:{
    Date(value){
      const date= new Date(value);
      const Mou=date.getMonth()+1
      return Mou+'-'+date.getDate()
    }
  }
}
</script>

<style lang="less" scoped>
.item-base{
  width: 30%;
  .item-img{
    width: 100%;
    height: 312px;
    overflow: hidden;
    .img{
      width: 100%;
      height: 312px;
      border-radius: 2px;
      object-fit: cover;
      transition: all 0.6s ease;
      &:hover{
        transform: scale(1.1);
      }
    }
  }
  .item-title{
    width: 100%;
    margin: 2px 0;
    /*min-height: 72px;*/
    span{
      display: flex;
      margin: 8px 0;
      &:first-child{
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 36px;
        text-indent: 5px;
      }
      width: 100%;
      height: 72px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .item-time{
    width: 96%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding-right: 8px;
    span{
      &:first-child{
        i{
          font-size: 14px;
        }
        &:hover{
          color: #188ACB;
        }
      }
      display: block;
      //width: 85px;
      height: 16px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      line-height: 24px;

    }
  }
}
</style>